module.exports = __webpack_public_path__ + "img/team-logo-white.42a3a16f.svg";